import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_LaunchUrls } from '@app/org-shared';
export const dispatch_onLaunchUrlsChanged = new ThunderDispatcherV3('__onLaunchUrlsUpdated');
export class ModuleFE_LaunchUrls_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_LaunchUrls, dispatch_onLaunchUrlsChanged);
    }
}
export const ModuleFE_LaunchUrls = new ModuleFE_LaunchUrls_Class();
//# sourceMappingURL=ModuleFE_LaunchUrls.js.map